import { render, staticRenderFns } from "./ViewerComponent.vue?vue&type=template&id=58ead30a&scoped=true&"
import script from "./ViewerComponent.vue?vue&type=script&lang=js&"
export * from "./ViewerComponent.vue?vue&type=script&lang=js&"
import style0 from "./ViewerComponent.vue?vue&type=style&index=0&id=58ead30a&prod&lang=scss&scoped=true&"
import style1 from "./ViewerComponent.vue?vue&type=style&index=1&id=58ead30a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ead30a",
  null
  
)

export default component.exports